import i18next from 'i18next';
import { inAnteprima } from '../skin';

/**
 * ERRORI DELLE PAGINE DEL CONTO (profilo, password, cassa), come li legge un
 * giocatore: una frase semplice e «(codice N)» per l'assistenza. Il testo
 * tecnico («Request failed with status code 500», l'eccezione del servizio)
 * si vede solo nell'anteprima del backoffice.
 */

/** Il numero da dare all'assistenza: lo stato HTTP, oppure «rete» se non e' arrivata risposta. */
export function codiceDi(e) {
  const s = e && e.response && e.response.status;
  if (s) return s;
  return e && (e.request || e.isAxiosError) ? 'rete' : null;
}

/**
 * La frase del servizio, solo quando e' scritta per una persona: un rifiuto
 * (4xx, o senza stato) con un messaggio vero. Un 500 porta spesso l'eccezione Java, e quella
 * non va mostrata.
 *
 * LA LINGUA: il servizio scrive in italiano. In un'altra lingua la sua frase
 * si mostra solo se il dizionario la conosce; se no si torna null e la
 * pagina scrive la sua frase di ripiego, che e' tradotta: mai un pezzo di
 * italiano in mezzo a una pagina in inglese.
 */
export function fraseDelServizio(e) {
  const s = e && e.response && e.response.status;
  const m = e && e.response && e.response.data && e.response.data.message;
  if ((s && s >= 500) || typeof m !== 'string') return null;
  const t = m.trim();
  if (!t || /exception|request failed|status code|stack|null/i.test(t)) return null;
  return nellaLingua(t);
}

/**
 * Una frase scritta dal servizio (in italiano), nella lingua di chi guarda:
 * tradotta se il dizionario la conosce, com'e' se chi guarda legge
 * l'italiano, altrimenti null (e chi chiama scrive la sua frase di ripiego).
 */
export function nellaLingua(m) {
  if (typeof m !== 'string' || !m.trim()) return null;
  const t = m.trim();
  const lingua = i18next.language || 'it';
  if (!lingua.startsWith('it') && !i18next.exists(t)) return null;
  return i18next.t(t);
}

/** La frase (segnata con frase() da chi chiama) tradotta, e «(codice 500)», o niente se non c'e' un codice. */
export function conCodice(frase, e) {
  const c = codiceDi(e);
  const tradotta = i18next.t(frase);
  return c ? tradotta + ' ' + i18next.t('(codice {{codice}})', {codice: c}) : tradotta;
}

/** Il dettaglio tecnico, solo nell'anteprima del backoffice. */
export function tecnicoInAnteprima(e) {
  if (!inAnteprima() || !e) return null;
  const corpo = e.response && e.response.data;
  const dalServizio = corpo && (corpo.message || corpo.error);
  return [e.message, dalServizio].filter(Boolean).join(' · ') || null;
}
